
// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';

const bannerInfo=new BaseModule();
bannerInfo.name='banner-info';
bannerInfo.init();


